import { useEffect } from 'react';

interface SEOProps {
  title: string;
  description: string;
  noindex?: boolean;
}

export function useSEO({ title, description, noindex = false }: SEOProps) {
  useEffect(() => {
    // Set document title
    document.title = `${title} | Polaris`;

    // Set or update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', description);

    // Set or update robots meta
    let metaRobots = document.querySelector('meta[name="robots"]');
    if (!metaRobots) {
      metaRobots = document.createElement('meta');
      metaRobots.setAttribute('name', 'robots');
      document.head.appendChild(metaRobots);
    }
    metaRobots.setAttribute('content', noindex ? 'noindex, nofollow' : 'index, follow');

    // Cleanup - reset to default on unmount
    return () => {
      document.title = 'Polaris';
    };
  }, [title, description, noindex]);
}
